import React from 'react';
import {
  Text,
  TextTypography as TYPOGRAPHY,
  Dialog as DialogComponent,
  Button,
} from 'wix-ui-tpa';
import { classes, st } from './Dialog.st.css';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { DataHooks } from './consts';

export type DialogProps = {
  isOpen: boolean;
  content: string;
  confirmationButtonLabel: string;
  onClose: () => void;
};

export const Dialog: React.FC<DialogProps> = (props) => {
  const { isMobile } = useEnvironment();
  const { isOpen, content, confirmationButtonLabel, onClose } = props;

  return (
    <DialogComponent
      data-hook={DataHooks.WRAPPER}
      isOpen={isOpen}
      onClose={onClose}
      className={st(classes.root, { isMobile })}
      notFullscreenOnMobile
    >
      <Text
        className={classes.content}
        data-hook={DataHooks.CONTENT}
        typography={TYPOGRAPHY.runningText}
      >
        {content}
      </Text>
      <Button
        className={classes.button}
        onClick={onClose}
        data-hook={DataHooks.CONFIRMATION_BUTTON}
        fullWidth={isMobile}
      >
        {confirmationButtonLabel}
      </Button>
    </DialogComponent>
  );
};
